/* Cart "You may also like" - Comma (Oct 2026)
   Swaps the cart drawer's recommendation cards for the site's normal
   collection tiles (small "+" quick add + colour swatches).

   - Cart has items: tiles go in the "You may also like" row under the items,
     based on the first item in the cart (Shopify's own recommendations).
   - Cart is empty: tiles go under "Your cart is empty", best-selling jerseys.
   Loads when the drawer first opens, then refreshes when the cart changes. */
(function () {
  var SECTION = 'cart-ymal-grid';
  var EMPTY_URL = '/collections/jerseys?sort_by=best-selling&section_id=' + SECTION;
  var lastKey = null;
  var loading = false;

  function drawer() {
    return document.getElementById('cart-drawer');
  }

  // The two places tiles go: the row under the items, and the empty-cart list
  function targets() {
    var d = drawer();
    if (!d) return {};
    return {
      row: d.querySelector('.cart-drawer__collection .cart-swiperContainer_in'),
      empty: d.querySelector('.cart_empty_product .cartEmpty_product_row'),
    };
  }

  function holder(parent) {
    if (!parent) return null;
    var el = parent.querySelector(':scope > .cart-ymal');
    if (!el) {
      el = document.createElement('div');
      el.className = 'cart-ymal';
      parent.insertBefore(el, parent.firstChild);
    }
    return el;
  }

  function fetchTiles(url) {
    return fetch(url)
      .then(function (res) { return res.ok ? res.text() : ''; })
      .then(function (html) {
        if (!html) return '';
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-cart-ymal]');
        return el ? el.innerHTML : '';
      })
      .catch(function () { return ''; });
  }

  function fill(el, html) {
    if (!el) return;
    el.innerHTML = html;
    // Show images straight away (scroll animations don't fire inside the drawer)
    el.querySelectorAll('[data-aos]').forEach(function (n) { n.removeAttribute('data-aos'); });
    // Hook up variant sync for the new tiles if the theme provides it
    if (typeof window.initGridVariantSyncItem === 'function') {
      el.querySelectorAll('[data-product-grid-item]').forEach(function (tile) {
        try { window.initGridVariantSyncItem(tile); } catch (e) {}
      });
    }
    el.classList.toggle('is-empty', !el.querySelector('[data-product-grid-item]'));
    if (el.closest('.cart-drawer__collection')) addArrows(el);
  }

  /* Arrows for the row under the items (desktop / mouse only - phones swipe).
     Each click moves one tile; arrows hide at the start and end of the row. */
  var ARROW_PREV = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 3L5 8L10 13" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  var ARROW_NEXT = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 3L11 8L6 13" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  function addArrows(el) {
    var row = el.querySelector('.cart-ymal__grid');
    if (!row) return;

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'cart-ymal__arrow cart-ymal__arrow--prev';
    prev.setAttribute('aria-label', 'Previous products');
    prev.innerHTML = ARROW_PREV;

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'cart-ymal__arrow cart-ymal__arrow--next';
    next.setAttribute('aria-label', 'More products');
    next.innerHTML = ARROW_NEXT;

    function step() {
      var tile = row.querySelector('[data-product-grid-item]');
      return tile ? tile.getBoundingClientRect().width + 10 : row.clientWidth;
    }
    function update() {
      var max = row.scrollWidth - row.clientWidth - 2;
      prev.style.display = row.scrollLeft > 2 ? '' : 'none';
      next.style.display = row.scrollLeft < max ? '' : 'none';
    }

    prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
    row.addEventListener('scroll', update, { passive: true });

    el.appendChild(prev);
    el.appendChild(next);
    update();
    // Re-check once images have sized the row
    setTimeout(update, 400);
  }

  function load() {
    if (loading) return;
    loading = true;
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var isEmpty = items.length === 0;
        var key = isEmpty ? 'empty' : String(items[0].product_id) + ':' + items.length;
        var d = drawer();
        if (d) d.classList.toggle('cart-ymal--cart-empty', isEmpty);
        if (key === lastKey) return null;
        lastKey = key;

        var t = targets();
        var url = isEmpty
          ? EMPTY_URL
          : '/recommendations/products?product_id=' + items[0].product_id + '&limit=10&section_id=' + SECTION;
        var target = holder(isEmpty ? t.empty : t.row);
        return fetchTiles(url).then(function (html) { fill(target, html); });
      })
      .catch(function () {})
      .then(function () { loading = false; });
  }

  // Load the first time the drawer opens (its class / attributes change)
  function watchDrawer() {
    var d = drawer();
    if (!d) return;
    var obs = new MutationObserver(function () { load(); });
    obs.observe(d, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden'] });
  }

  // Refresh when items are added or removed
  document.addEventListener('theme:cart:change', function () {
    setTimeout(load, 150);
  });

  function start() {
    watchDrawer();
    // Warm up quietly a few seconds after the page settles
    setTimeout(load, 4000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
